module.exports = __webpack_public_path__ + "static/media/25_Days_Holiday.0468ba14.svg";